import type React from 'react'
import { Button, Message, Modal, Paragraph } from 'ui'
import { BlockModalProps, BlockModalType } from './types'

type Props = BlockModalProps & {
  worker: {
    name?: string
  }
}

export function FillRate(props: Props) {
  const { isOpen, onClose, onNext, worker } = props

  const handleBlockClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    onNext(BlockModalType.Block)
  }

  return (
    <Modal
      title={'Warning: Blocking may reduce your fill rate'}
      open={isOpen}
      onClose={() => onClose()}
      customCta={
        <>
          <Button variant={'text'} onClick={handleBlockClick}>
            Confirm and Block Worker
          </Button>
          <Button onClick={() => onNext(BlockModalType.Feedback)}>
            Give Feedback
          </Button>
        </>
      }
    >
      <Message variant={'warning'}>
        Blocking reduces the number of workers who can accept your shift.
      </Message>
      <Paragraph>
        Feedback can help {worker.name || 'this worker'} improve and become a
        valuable asset to your team.
      </Paragraph>
    </Modal>
  )
}
